import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';
import { ResponseService } from 'src/app/core/models/response-service.model';

@Injectable({
	providedIn: 'root',
})
export class ProspectsService {
	private currentProspect: any = null;
	currentCampaignId: string | null = null;
	currentCampaignAlias: string | null = null;
	currentPrimaryPhone: string | null = null;
	currentCampaignName: string | null = null;

	constructor(
		private http: HttpClient,
		private utils: UtilsService,
	) {}

	uploadProspects(prospects: any, campaignId: number) {
		const url = `${environment.api}prospects/upload_prospects`;
		const formData: any = this.utils.jsonToFormData({ prospects: JSON.stringify(prospects), campaignId: campaignId });
		return this.http.post(url, formData);
	}

	uploadFileProspects(formData, campaign_id: number, json_columns: string) {
		const url = `${environment.api}prospects/upload_file_prospects`;
		formData.append('campaign_id', campaign_id);
		formData.append('json_columns', json_columns);
		return this.http.post(url, formData);
	}

	getDisposByPhone(phone: string) {
		const url = `${environment.api}prospects/${phone}/get_dispos_by_phone`;
		return this.http.get(url);
	}
	setCurrentProspect(prospect: any) {
		this.currentProspect = prospect;
		this.currentCampaignId = prospect.campaign_id || null;
		this.currentCampaignAlias = prospect.alias || null;
		this.currentPrimaryPhone = prospect.primary_phone || null;
		this.currentCampaignName = prospect.campaign_name || null;
	}

	getCurrentProspect() {
		return this.currentProspect;
	}

	clearCurrentProspect() {
		this.currentProspect = null;
	}

	searchProspects(payload: any) {
		const url = `${environment.api}prospects/search`;
		payload = this.utils.jsonToFormData(payload);
		return this.http.post(url, payload);
	}

	public lead_detail(lead_id: number) {
		const url = `${environment.api}lead/${lead_id}/get_lead_by_id`;
		return this.http.get<ResponseService>(url);
	}

	getDispoLogNotes(prospect_id) {
		const url = `${environment.api}lead/${prospect_id}/get_dispo_log_notes`;
		return this.http.get<ResponseService>(url);
	}
}
